import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import {
  Button,
  Grid,
  IconButton,
  makeStyles,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Add } from "@material-ui/icons";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { theme } from "../constants/theme";
import {
  GeneralModal,
  SortButtonAndMenu,
  FilterButtonAndMenu,
  Searchbar,
} from "../components-molecules";
import { ClusteredList } from "../components-organisms";
import { HeaderWithButtons } from "../components-molecules";
import { usePrevious } from "../utils";
import { ButtonPrimary, PrimaryButton, ShopRegionHeadline } from "../components-atoms";
import { CircularProggressIndicator } from "../components-atoms";
import { getUnbindedSubcategories } from "../redux/actions/unbindedSubcategories";
import {
  bindSubcategories,
  clearBindSubcategories,
} from "../redux/actions/bindSubcategories";
import {
  getSubcategoriesSymbols,
  addNewSubcategory,
  getSubcategoriesSymbolsWithParams,
  updateSubcategory,
  clearSubCategorysSymbols,
} from "../redux/actions/getSubcategories";
import { getCategoriesSymbols } from "../redux/actions/getCategories";
import { getVerticalsSymbols } from "../redux/actions/getVerticals";
import {
  clearUnbindSubcategories,
  unbindSubcategories,
} from "../redux/actions/unbindSubcategories";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

// import { setError } from "../redux/actions/error";

export const Subcategories = (props: any) => {
  const classes = useStyles();
  const [sortType, setSortType] = useState("Asc");
  const [newCategoryName, setNewCategoryName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [editNameError, setEditNameError] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilters, setSelectedFilters] = useState<Object | null>();
  const [unbindModalVisible, setUnbindModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>();

  const [filter, setFilter] = useState<{
    Verticals: Array<string>;
    Categories: Array<string>;
  } | null>(null);
  const [filterType, setFilterType] = useState("");
  const [categoriesList, setCategoriesList] = useState<Array<any>>(
    props?.Category ? [props.Category] : []
  );
  const [selectedCategory, setSelectedCategory] = useState<{
    Id: string;
    Name: String;
  } | null>();
  const [categoryError, setCategoryError] = useState(false);
  const dispatch = useDispatch();
  const [openAddShopModal, setAddOpenShopModal] = useState<boolean>(false);
  const [bindSubCategoriesModalVisible, setBindSubCategoriesModalVisible] =
    useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [editSubCategory, setEditSubCategory] = useState<any>();
  const [unbindedData, setUnbindedData] = useState<Array<any>>();
  const debounceDuration = 500;

  const [
    categoryData,
    subcategoryData,
    loading,
    verticalData,
    unbindedSubcategoriesData,
    unbindedSubcategoriesLoading,
    bindSubcategoriesData,
    unbindSubcategoriesData,
  ] = useSelector((state: any) => [
    state.CategorySymbolsReducer.data,
    state.SubcategorySymbolsReducer.data,
    state.SubcategorySymbolsReducer.loading,
    state.VerticalSymbolsReducer.data,
    state.unbindedSubcategories.data,
    state.unbindedSubcategories.loading,
    state.bindSubcategories.data,
    state.unbindSubcategories.data,
  ]);

  useEffect(() => {
    dispatch(clearSubCategorysSymbols());
    if (props?.Category && props?.isUnderPage) {
      if (
        props.Category.VerticalId === null ||
        props.Category.Id === null ||
        props.Category.VerticalId === undefined ||
        props.Category.Id === undefined
      ) {
        return;
      }
      dispatch(
        getSubcategoriesSymbolsWithParams(
          searchTerm ? searchTerm : "",
          sortType.trim() === "" ? "Asc" : sortType,
          {
            Verticals: [props.Category.VerticalId],
            Categories: [props.Category.Id],
          }
        )
      );
      setFilter({
        Verticals: [props.Category.VerticalId],
        Categories: [props.Category.Id],
      });
    } else {
      dispatch(getSubcategoriesSymbols());
    }

    dispatch(getCategoriesSymbols());
    dispatch(getVerticalsSymbols());
    const categoriesAsOneArray: Array<any> = [];
    categoryData.forEach((element: Array<any>) => {
      if (element?.[1] && element[1].length > 0) {
        element[1].forEach((item: any) => categoriesAsOneArray.push(item));
      }
    });
    setCategoriesList(categoriesAsOneArray);
    props?.Category
      ? setSelectedCategory(props.Category)
      : setSelectedCategory(categoriesAsOneArray?.[0] ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.Category]);

  const prevCategory: any = usePrevious(props?.Category);
  useEffect(() => {
    if (prevCategory && prevCategory.Id === props?.Category?.Id) return;
    if (filter === null || filter === undefined) {
      return;
    }
    ((props?.Category && props?.isUnderPage) ||
      (!props?.Category && !props?.isUnderPage)) &&
      dispatch(
        getSubcategoriesSymbolsWithParams(
          searchTerm ? searchTerm : "",
          sortType.trim() === "" ? "Asc" : sortType,
          filter
        )
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortType, filter, prevCategory]);

  useEffect(() => {
    if (bindSubCategoriesModalVisible) {
      dispatch(getUnbindedSubcategories());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bindSubCategoriesModalVisible]);

  useEffect(() => {
    if (searchTerm) {
      debounce(() => {
        dispatch(
          getSubcategoriesSymbolsWithParams(
            searchTerm,
            sortType.trim() === "" ? "Asc" : sortType,
            filter
          )
        );
      }, debounceDuration)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    if (unbindSubcategoriesData === "Sub category unbinded.") {
      setUnbindModalVisible(false);
      setSelectedItem(undefined);
      dispatch(clearUnbindSubcategories());
      dispatch(
        getSubcategoriesSymbolsWithParams(
          searchTerm ? searchTerm : "",
          sortType.trim() === "" ? "Asc" : sortType,
          filter
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unbindSubcategoriesData]);

  useEffect(() => {
    if (unbindedSubcategoriesData.length !== 0) {
      const newUnbindedData = unbindedSubcategoriesData.map((group) => {
        const items = group.Items.map((item) => {
          return { ...item, isChecked: false };
        });
        return { ...group, Items: items };
      });
      setUnbindedData(newUnbindedData);
    }
  }, [unbindedSubcategoriesData]);

  useEffect(() => {
    if (bindSubcategoriesData === "Category binded.") {
      dispatch(clearBindSubcategories());
      if (props?.Category && props?.isUnderPage) {
        dispatch(
          getSubcategoriesSymbolsWithParams(
            searchTerm ? searchTerm : "",
            sortType.trim() === "" ? "Asc" : sortType,
            {
              Verticals: [props.Category.VerticalId],
              Categories: [props.Category.Id],
            }
          )
        );
        setFilter({
          Verticals: [props.Category.VerticalId],
          Categories: [props.Category.Id],
        });
      } else {
        dispatch(getSubcategoriesSymbols());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bindSubcategoriesData]);

  const handleSubmit = () => {
    if (newCategoryName.trim() === "") {
      setNameError(true);
      return;
    }
    if (!selectedCategory || !selectedCategory?.Id) {
      setCategoryError(true);
      return;
    }
    const body = {
      Name: newCategoryName,
      CategoryId: props?.Category ? props?.Category?.Id : selectedCategory?.Id,
    };
    dispatch(
      addNewSubcategory(body, null, () => {
        setNewCategoryName("");
        setSelectedCategory(props?.Category ?? null);
        setAddOpenShopModal(false);
        setCategoryError(false);
        if (props?.Category) {
          dispatch(
            getSubcategoriesSymbolsWithParams(
              searchTerm ? searchTerm : "",
              sortType.trim() === "" ? "Asc" : sortType,
              {
                Verticals: [props.Category.VerticalId],
                Categories: [props.Category.Id],
              }
            )
          );
        } else {
          dispatch(getSubcategoriesSymbols());
        }
      })
    );
  };

  const handleBindSubcategories = () => {
    let selectedSubcategoryIds: Array<string> = [];
    dispatch(clearBindSubcategories());
    unbindedData?.forEach((group) => {
      group.Items.forEach((item) => {
        if (item.isChecked) {
          selectedSubcategoryIds.push(item.Id);
        }
      });
    });
    dispatch(bindSubcategories(props.Category.Id, selectedSubcategoryIds));
    setBindSubCategoriesModalVisible(false);
  };

  const handleEditSubmit = () => {
    if (editSubCategory.Name.trim() === "") {
      setEditNameError(true);
      return;
    }
    if (!selectedCategory || !selectedCategory?.Id) {
      setCategoryError(true);
      return;
    }
    const body = {
      Name: editSubCategory.Name,
      CategoryId: props?.Category
        ? props?.Category?.Id
        : selectedCategory
        ? selectedCategory?.Id
        : editSubCategory.Id,
    };
    dispatch(
      updateSubcategory(editSubCategory.Id, body, null, () => {
        setEditSubCategory(null);
        setSelectedCategory(props?.Category ?? null);
        setOpenEditModal(false);
        setEditNameError(false);
        setCategoryError(false);
        if (props?.Category) {
          dispatch(
            getSubcategoriesSymbolsWithParams(
              searchTerm ? searchTerm : "",
              sortType.trim() === "" ? "Asc" : sortType,
              {
                Verticals: [props.Category.VerticalId],
                Categories: [props.Category.Id],
              }
            )
          );
        } else {
          dispatch(getSubcategoriesSymbols());
        }
      })
    );
  };

  const bottomTextCreator = useCallback((item: any) => {
    const vName = categoryData.find(
      (itm: any) => itm.Id === item.CategoryId
    )?.VerticalName;

    return `${item?.VerticalName}${
      item?.VerticalName.length === 0 && item?.CategoryTitle.length === 0
        ? ""
        : " \u2022 "
    }${vName ? vName + " · " : ""}${
      item?.CategoryTitle ?? "(Unnamed Category)"
    } · ${item?.ProductCount ?? 0} ${
      item?.ProductCount === 1 ? "Product" : "Products"
    }`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const topTextCreator = useCallback(
    (item: any) => `${item?.Name ?? "Unnamed SubCategory"}`,
    []
  );

  const pathCreator = useCallback(
    (item: any) => {
      if (item?.Id) {
        const path = `/admin/subcategory/${item?.Id}`;
        return path;
      } else {
        return null;
      }
    },
    []
  );

  const updateList = ({ search, order, filter }) => {
    dispatch(
      getSubcategoriesSymbolsWithParams(search ? search : "", order, filter)
    );
  };

  const checkboxChanged = (selectedItem, value) => {
    const newUnbindedData = unbindedData?.map((group) => {
      const items = group.Items.map((item) => {
        if (selectedItem.Id === item.Id) {
          return { ...item, isChecked: value };
        } else {
          return item;
        }
      });
      return { ...group, Items: items };
    });
    setUnbindedData(newUnbindedData);
  };

  const handleUnbindSubcategories = () => {
    dispatch(unbindSubcategories(selectedItem?.Id));
  };
  const checkUnbindedDataHasCheckedItems = () => {
    let disable = true;
    unbindedData?.forEach((x) => {
      x.Items.forEach((item) => {
        if (item.isChecked) {
          disable = false;
        }
      });
    });
    return disable;
  };

  return (
    <div className={classes.container}>
      <CssBaseline />
      <div className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons title="">
          <HeaderWithButtons.ButtonArea>
            <div className={classes.mgLeftAuto}>
              <SortButtonAndMenu
                menuItems={[
                  {
                    title: "Alphabetical ascending",
                    value: "Asc",
                    handleSelect: () => {
                      setSortType("Asc");
                      updateList({
                        search: "",
                        order: "Asc",
                        filter: filter,
                      });
                    },
                  },
                  {
                    title: "Alphabetical descending",
                    value: "Desc",
                    handleSelect: () => {
                      setSortType("Desc");
                      updateList({
                        search: "",
                        order: "Desc",
                        filter: filter,
                      });
                    },
                  },
                ]}
                selectedSortType={sortType}
              />
              {!props?.Category && (
                <FilterButtonAndMenu
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  addRemoveFilter={(newFilters: any) => {
                    setFilter(newFilters);
                  }}
                  setFilterTypeSelected={(item: string) => {
                    setFilterType(item);
                  }}
                  filterTypeDataDetails={
                    filterType === "Verticals" ? verticalData : categoryData
                  }
                  filterTypeList={[
                    { title: "Verticals", typeKey: "Verticals" },
                    { title: "Categories", typeKey: "Categories" },
                  ]}
                />
              )}
              <IconButton
                data-automation="search-button"
                className={classes.searchIconButton}
                color="primary"
                onClick={() => setOpenSearch(true)}
              >
                <SearchRoundedIcon
                  color="primary"
                  className={classes.searchIcon}
                />
              </IconButton>
              {props.isUnderPage && (
                <ButtonPrimary
                  data-automation="add-vertical-button"
                  variant="contained"
                  color="primary"
                  disableElevation
                  className={classes.primaryButton}
                  style={{
                    paddingLeft: props.loading ? "12px" : "16px",
                  }}
                  startIcon={<Add />}
                  onClick={() => {
                    if (props?.isUnderPage) {
                      setBindSubCategoriesModalVisible(true);
                    } else {
                      setAddOpenShopModal(true);
                    }
                  }}
                >
                  Add Sub Categories
                </ButtonPrimary>
              )}
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        <Searchbar
          query={searchTerm}
          isOpen={openSearch}
          placeholder="Search Subcategories"
          onCancel={() => {
            setOpenSearch(false);
            setSearchTerm("");
            updateList({
              search: "",
              order: sortType,
              filter: filter,
            });
          }}
          onChange={(event) =>
            debounce(
              (e) => setSearchTerm(e.target.value),
              debounceDuration
            )(event)
          }
        />
        {loading ? (
          <>
            <CircularProggressIndicator />
          </>
        ) : (
          <ClusteredList
            data={subcategoryData ?? []}
            bottomTextCreator={bottomTextCreator}
            topTextCreator={topTextCreator}
            pathCreator={pathCreator}
            headlineTypeSingular="Sub Category"
            headLineTypePlural="Sub Categories"
            threeDotMenuItems={[
              {
                name: "Unbind sub category",
                callback: (item: any) => {
                  setSelectedItem(item);
                  setUnbindModalVisible(true);
                },
              },
            ]}
          />
        )}
      </div>
      <GeneralModal
        title="Add Sub Categories"
        description="Select a category you are creating the sub category for. Give category a name. Once created you will be able to add sub categories."
        visible={openAddShopModal}
        onClose={setAddOpenShopModal}
        onSubmit={handleSubmit}
        modalWidth="560px"
      >
        <GeneralModal.ContentArea>
          <Grid container>
            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                className={classes.selectArea}
                error={categoryError}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={
                    props?.Category
                      ? props.Category.Id
                      : selectedCategory
                      ? selectedCategory?.Id
                      : categoriesList && categoriesList?.[0]
                      ? categoriesList[0].Id
                      : ""
                  }
                  disabled={props?.Category ? true : false}
                  onChange={(event: any) => {
                    if (props?.Category) return;
                    setSelectedCategory(
                      categoriesList?.find(
                        (item: any) => item.Id === event.target.value
                      )
                    );
                  }}
                  label="Category"
                >
                  {categoriesList &&
                    categoriesList.map((v: any) => (
                      <MenuItem value={v.Id}>{v.Name}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                placeholder="Subcategory Name"
                value={newCategoryName}
                variant="outlined"
                margin="normal"
                fullWidth
                id="CategoryName"
                label="Subcategory Name"
                name="CategoryName"
                onChange={(event: any) =>
                  setNewCategoryName(event.target.value)
                }
                error={nameError}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
            </Grid>
          </Grid>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setAddOpenShopModal(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setNameError(false);
                setNewCategoryName("");
                setSelectedCategory(props?.Category);
                setAddOpenShopModal(false);
                setCategoryError(false);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <PrimaryButton onClick={handleSubmit} title="Submit" />
        </GeneralModal.ButtonArea>
      </GeneralModal>

      {/* Edit/Update Modal */}

      <GeneralModal
        title="Edit Sub Category"
        description="Select a category you are creating the sub category for. Give category a name. Once created you will be able to add sub categories."
        visible={openEditModal}
        onClose={setOpenEditModal}
        onSubmit={handleEditSubmit}
        modalWidth="560px"
      >
        <GeneralModal.ContentArea>
          <Grid container>
            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                className={classes.selectArea}
                error={categoryError}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={
                    props?.Category
                      ? props.Category.Id
                      : selectedCategory
                      ? selectedCategory?.Id
                      : categoriesList && categoriesList?.[0]
                      ? categoriesList[0].Id
                      : ""
                  }
                  disabled={props?.Category ? true : false}
                  onChange={(event: any) => {
                    if (props?.Category) return;
                    setSelectedCategory(
                      categoriesList?.find(
                        (item: any) => item.Id === event.target.value
                      )
                    );
                  }}
                  label="Category"
                >
                  {categoriesList &&
                    categoriesList.map((v: any) => (
                      <MenuItem value={v.Id}>{v.Name}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                placeholder="Subcategory Name"
                value={editSubCategory?.Name}
                variant="outlined"
                margin="normal"
                fullWidth
                id="CategoryName"
                label="Subcategory Name"
                name="CategoryName"
                onChange={(event: any) => {
                  const newsubCategory = { ...editSubCategory };
                  newsubCategory.Name = event.target.value;
                  setEditSubCategory(newsubCategory);
                }}
                error={editNameError}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              />
            </Grid>
          </Grid>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setOpenEditModal(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setEditSubCategory(null);
                setSelectedCategory(props?.Category);
                setOpenEditModal(false);
                setCategoryError(false);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <PrimaryButton onClick={handleEditSubmit} title="Submit" />
        </GeneralModal.ButtonArea>
      </GeneralModal>
      {/* Bind subcategories to categories modal  */}

      <GeneralModal
        title="Unbind sub category"
        visible={unbindModalVisible}
        onClose={() => {
          setSelectedItem(undefined);
          setUnbindModalVisible(false);
        }}
        //onSubmit={handleBindSubcategories}
        modalWidth="480px"
      >
        <GeneralModal.ContentArea>
          <Grid container style={{ marginTop: 12, marginBottom: 12 }}>
            <Grid item xs={12}>
              <Typography variant="body2" component="span" color="textPrimary">
                Are you sure you want to unbind this sub category from the
                category?
              </Typography>
            </Grid>
          </Grid>
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setBindSubCategoriesModalVisible(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setUnbindModalVisible(false);
                setSelectedItem(undefined);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <Button
            onClick={handleUnbindSubcategories}
            className={classes.unbindButton}
            style={{ width: undefined }}
          >
            <Typography variant="button" component="p" color="inherit">
              Yes, unbind sub category
            </Typography>
          </Button>
        </GeneralModal.ButtonArea>
      </GeneralModal>
      <GeneralModal
        title="Add Sub Categories"
        visible={bindSubCategoriesModalVisible}
        onClose={setBindSubCategoriesModalVisible}
        onSubmit={handleBindSubcategories}
        modalWidth="480px"
        changePaddingLeft
      >
        <GeneralModal.ContentArea>
          {unbindedSubcategoriesLoading ? (
            <CircularProggressIndicator />
          ) : (
            <Grid container style={{ maxHeight: 560, overflowY: "auto" }}>
              <Grid item xs={12}>
                {unbindedData?.map((item: any, index: any) => (
                  <div key={index}>
                    {item.Items.length > 0 && (
                      <ShopRegionHeadline
                        key={index}
                        headlineTypeSingular="Sub Category"
                        headLineTypePlural="Sub Categories"
                        data={{
                          header: item.FirstLetter,
                          count: item.Items?.length,
                        }}
                      />
                    )}
                    {item.Items.map((itm: any, index: number) => (
                      <div className={classes.unbinddedItem}>
                        <div>
                          <Checkbox
                            checked={itm.isChecked}
                            value="remember"
                            color="primary"
                            onChange={(event) =>
                              checkboxChanged(itm, event.target.checked)
                            }
                          />
                        </div>
                        <div className={classes.unbinddedTextSection}>
                          <div className={classes.pb4}>
                            <Typography
                              variant="body1"
                              component="span"
                              color="textPrimary"
                            >
                              {itm?.Name}
                            </Typography>
                          </div>
                          <div>
                            <Typography
                              variant="body2"
                              component="span"
                              color="textPrimary"
                            >
                              {`${itm?.ProductCount ?? 0} ${
                                itm?.ProductCount === 1 ? "Product" : "Products"
                              }`}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </Grid>
            </Grid>
          )}
        </GeneralModal.ContentArea>
        <GeneralModal.ButtonArea>
          <Button
            onClick={() => {
              setBindSubCategoriesModalVisible(false);
            }}
            className={classes.cancelButton}
          >
            <Typography
              onClick={() => {
                setNameError(false);
                setNewCategoryName("");
                setSelectedCategory(props?.Category);
                setAddOpenShopModal(false);
                setCategoryError(false);
              }}
              variant="button"
              component="p"
              color="primary"
            >
              Cancel
            </Typography>
          </Button>
          <PrimaryButton
            onClick={handleBindSubcategories}
            disabled={checkUnbindedDataHasCheckedItems()}
            title="Add"
          />
        </GeneralModal.ButtonArea>
      </GeneralModal>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    ...textButtonHoverAndActive
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  mgLeftAuto: {
    display: "flex",
    flexDirection: "row",
    paddingRight: 24,
  },
  unbindButton: {
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary[16],
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[32],
    },
  },

  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  selectArea: { width: "100%", marginBottom: 15 },
  primaryButton: {
    marginLeft: 8,
    borderRadius: 8,
  },
  unbinddedItem: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    alignItems: "center",
    "&:nth-child(2)": {
      paddingTop: 2,
    },
    "&:last-child": {
      paddingBottom: 26,
    },
  },
  unbinddedTextSection: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginLeft: 8,
  },
  pb4: {
    paddingBottom: 4,
  },
});
